import { Injectable } from '@angular/core';
import { TableColumn } from '../models/table-column.model';
import { getDateForFilename, FileSaverService } from '@core';

@Injectable({
  providedIn: 'root'
})
export class TableService {

  constructor(private _fileSaverService: FileSaverService) { }

  public tableName: string;

  public exportToCsv<T>(columns: TableColumn[], rows: T[], filename: string = '') {
    filename = filename === '' ? `${this.tableName}${getDateForFilename()}.csv` : filename;
    if (!rows || !rows.length) {
      return;
    }

    const csvContent = this.convertTableDataToCsvFormat(columns, rows);
    const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]) /* UTF-8 BOM */, csvContent], { type: 'text/csv;charset=utf-8' });
    this._fileSaverService
      .saveBlob(blob, filename);
  }

  private convertTableDataToCsvFormat<T>(columns: TableColumn[], rows: T[]): string {

    const exportableColumns = columns.filter(c => c.exportable !== false && c.display !== 'hidden');
    const separator = ';';
    const headerRow = exportableColumns
      .map(c => c.title)
      .join(separator)

    const dataRows = rows
      .map(row => exportableColumns.map(c => {
          let cell = c.toExport(row, 'csv') || '';
          cell = cell instanceof Date ? cell.toLocaleString() : cell.toString().replace(/"/g, '""');
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        }).join(separator)
      );

    return [headerRow, ...dataRows].join('\n');
  }

  public exportToJson<T>(rows: T[], filename: string = '') {
    filename = filename === '' ? `${this.tableName}${getDateForFilename()}.json` : filename;

    this._fileSaverService.saveAsJson(rows, filename);
  }

  public loadSavedColumnInfo(columnInfo: TableColumn[], saveName?: string): TableColumn[] {
    // Only load if a save name is passed in
    if (saveName) {
      if (!localStorage) {
        return [];
      }

      const loadedInfo = localStorage.getItem(`${saveName}-columns`);

      if (loadedInfo) {
        return JSON.parse(loadedInfo);
      }
      this.saveColumnInfo(columnInfo);
      return columnInfo;
    }
    return [];
  }

  public saveColumnInfo(columnInfo: TableColumn[], saveName: string = this.tableName): void {
    if (saveName) {
      if (!localStorage) {
        return;
      }

      localStorage.setItem(`${saveName}-columns`, JSON.stringify(columnInfo));
    }
  }
}
